@switch (openPage) {
    @case (Pages.ALTERNATIVE_WAYS_LIVENESS) {
        <div fxLayout="column"
             fxLayoutAlign="center center"
             class="liveness-closed-main-container pl-8 pr-8 h-100 overflow-y radius-16"
             ngClass.mobile="ignore-back-logos"
             fxFlexAlign="start"
             fxFlex>
            <div fxLayout="column"
                 class="main-shadow radius-16 bc-mono-white liveness-closed-container w-100 pt-48 pb-80"
                 fxLayoutAlign="start center">
                <div class="h3-semi-bold text-center c-primary-gray-900 pre-line">
                    {{ 'i18n_auth_selectWayToPassLivenessTitle' | translate }}
                </div>
                <div class="t2 mt-16 pre-line text-center">{{ 'i18n_auth_selectWayToPassLivenessSubtitle' | translate }}</div>
                <div fxLayout.desktop="row" fxLayout.mobile="column" fxLayoutAlign="space-between center" class="w-100 mt-56 h-100">
                    <div fxLayout="column" fxLayoutAlign="center center" class="w-100">
                        <ui-kit-svg class="i-80" [name]="!isMobile ? 'ic_desktop': 'ic_scan_qr'"/>
                        <div
                            class="mt-16 t2 c-primary-gray-900">{{ (!isMobile ? 'i18n_auth_continueLivenessDescriptionDesktop' : 'i18n_auth_continueLivenessDescriptionDesktopMobile') | translate }}
                        </div>
                        <ui-kit-button class="mt-16" [label]="'i18n_auth_buttonTryAgain' | translate" (clickListener)="restartLiveness()"/>
                    </div>
                    <div class="mt-16 t2 c-primary-gray-900"
                         [ngClass.mobile]="'mt-32'">{{ 'i18n_auth_continueLivenessDescriptionOr' | translate }}
                    </div>
                    <div fxLayout="column" fxLayoutAlign="center center" class="w-100" ngClass.mobile="'mt-32'">
                        <ui-kit-svg class="i-80" [name]="!isMobile ? 'ic_scan_qr' : 'ic_scan_qr_mobile'"/>
                        <div
                            class="mt-16 t2 c-primary-gray-900">{{ (!isMobile ? 'i18n_auth_continueLivenessDescriptionMobile' : 'i18n_auth_continueLivenessDescriptionMobileMobile') | translate }}
                        </div>
                        <ui-kit-button class="mt-16" [label]="'i18n_auth_buttonScanQr' | translate" (clickListener)="showQr()"/>
                    </div>
                </div>
            </div>
        </div>
    }
    @case (Pages.RETRY) {
        <div fxFlex
             fxLayout="column"
             fxLayoutAlign="center center"
             class="liveness-closed-main-container pl-8 pr-8">
            <auth-liveness-retry [retryIconName]="retryIconName" [retryStatus]="retryStatus" [buttonType]="buttonType" (retry)="retry()"/>
        </div>
    }
    @case (Pages.QR) {
        @if (qrAppearance) {
            <div fxLayout="column"
                 fxLayoutAlign="center center"
                 fxFlex>
                <auth-liveness-create-qr [qrAppearance]="qrAppearance"/>
            </div>
        }
    }
    @case (Pages.LIVENESS) {
        <auth-liveness class="h-100" (livenessResponseEvent)="handleLivenessResponse($event)"/>
    }
}
